module.exports = __webpack_public_path__ + "img/aufzugoBanner.31d2eff.webp";